import { Box, Typography } from '@mui/material';

import {
  ActionIconButton,
  CustomTextField,
} from '../../../../common/components';
import { VAT_RATE_OPTIONS } from '../../constants/supplierLedgerUiConstants';
import { calculateAmountLine } from '../../utils/supplierLedgerHelpers';
import { formatCurrencyAmount } from '../../utils/supplierLedgerFormatters';
import { FieldSelect } from './SupplierLedgerFormFields';

export const AmountLineCalculatedSummary = ({ net, vat }) => (
  <Box
    sx={{
      gridColumn: '1 / -1',
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
      gap: 1,
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1,
      px: 1,
      py: 0.75,
      backgroundColor: 'background.formTables',
      minWidth: 0,
    }}
  >
    {[
      { label: 'Neto calculado', value: net },
      { label: 'IVA calculado', value: vat },
    ].map((item) => (
      <Box
        key={item.label}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
          gap: 1,
          minWidth: 0,
          minHeight: 30,
          px: 1,
        }}
      >
        <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 700, lineHeight: 1.2, minWidth: 0 }}>
          {item.label}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: 'text.primary', fontWeight: 800, lineHeight: 1.2, whiteSpace: 'nowrap' }}
          title={String(item.value || '-')}
        >
          {item.value || '-'}
        </Typography>
      </Box>
    ))}
  </Box>
);

export const AmountLineRow = ({
  line,
  index,
  currency,
  canRemove,
  disabled = false,
  onChange,
  onRemove,
}) => {
  const lineAmounts = calculateAmountLine(line);

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, minmax(0, 1fr))',
          md: '36px minmax(0, 1fr) 140px 56px',
        },
        gap: 1.25,
        alignItems: 'start',
        p: 1.25,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        backgroundColor: 'background.paper',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: { xs: 'flex-start', md: 'center' },
          minHeight: 56,
          mt: '12px',
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          color: 'primary.main',
          fontWeight: 800,
          fontSize: '0.9rem',
          backgroundColor: 'background.formTables',
          px: { xs: 1.5, md: 0 },
          gridColumn: { xs: 'span 1', sm: 'span 2', md: 'auto' },
        }}
      >
        <Box component="span" sx={{ display: { xs: 'inline', md: 'none' } }}>
          {`Importe ${index + 1}`}
        </Box>
        <Box component="span" sx={{ display: { xs: 'none', md: 'inline' } }}>
          {index + 1}
        </Box>
      </Box>
      <CustomTextField
        label="Total con IVA"
        name={`amount-${line.id}`}
        value={line.gross_amount}
        onChange={(event) => onChange(line.id, 'gross_amount', event.target.value)}
        placeholder="0,00"
        disabled={disabled}
      />
      <FieldSelect
        label="IVA %"
        name={`vat-rate-${line.id}`}
        value={line.vat_rate}
        onChange={(event) => onChange(line.id, 'vat_rate', event.target.value)}
        options={VAT_RATE_OPTIONS}
        sx={{ width: '100%', pointerEvents: disabled ? 'none' : 'auto', opacity: disabled ? 0.65 : 1 }}
      />
      <Box
        sx={{
          mt: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: { xs: 'flex-start', md: 'center' },
          minHeight: 56,
          gridColumn: { xs: 'span 1', sm: 'span 2', md: 'auto' },
        }}
      >
        <ActionIconButton
          variant="delete"
          aria-label={`Quitar importe ${index + 1}`}
          onClick={() => onRemove(line.id)}
          disabled={disabled || (!canRemove && !line.gross_amount)}
          sx={{ height: 56, width: 56, minWidth: 56 }}
        />
      </Box>
      <AmountLineCalculatedSummary
        net={formatCurrencyAmount(lineAmounts.net, currency)}
        vat={formatCurrencyAmount(lineAmounts.vat, currency)}
      />
    </Box>
  );
};
